import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-content">
          <div className="footer-column">
            <h4>Shopping Online</h4>
            <ul>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns Policy
                </Link>
              </li>

              <li>
                <Link to="/shipping" onClick={toTop}>
                  Delivery Information
                </Link>
              </li>
              <li>
                <Link to="/faqs" onClick={toTop}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>More Information</h4>
            <ul>
              <li>
                <Link to="/about" onClick={toTop}>
                  Stories
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>

              <li>
                <Link to="/about" onClick={toTop}>
                  Our History
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column social-column">
            <h4>Contact</h4>
            <a href="mailto:level@failblossom.lifestyle">
              level@failblossom.lifestyle
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-links">
          <Link to="/terms" onClick={toTop}>
            Terms of Use
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy Policy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie Policy
          </Link>
        </div>

        <div className="footer-currency">
          <span className="flag">🇬🇧</span>
          <span className="currency">GB / £ GBP</span>
        </div>
      </div>

      <div className="footer-copyright">
        <p>
          © failblossom 2026 All Rights Reserved · 181 Piccadilly, London W1A
          1ER · level@failblossom.lifestyle
        </p>
      </div>
    </footer>
  );
}

export default Footer;
